import React from "react";

import { useAuth } from "hooks/useAuth";
import { useTranslation } from "react-i18next";

import { Link } from 'react-router-dom';

export function Welcome(){
    const { t } = useTranslation("common");
    const { user } = useAuth();
    return <div className="flex w-full px-3 md:px-6 md:justify-end">
        <Link to={"/"} className="md:hidden">
            <img src="/assets/logo-HD.png" className="h-6"/>
        </Link>
        {user && <Link to={"/settings/security"} className="hidden text-orange-500 md:block">{user.name} ({t(user.role)})</Link>}
    </div>
}

export function WelcomeNav(){

    const { t } = useTranslation("common");
    const { user } = useAuth();
    return <div className="">
        <Link to={"/"} className="flex justify-center md:hidden">
            <img src="/assets/logo-HD.png" className="h-8 mb-2"/>
        </Link>
        {   user && <>
                <div className="text-orange-500">{user.name}</div>
                <div className="text-sm text-gray-400">{t(user.role)}</div>
            </>
        }
    </div>
}